import { render, staticRenderFns } from "./addProductType.vue?vue&type=template&id=35c97025&scoped=true&"
import script from "./addProductType.vue?vue&type=script&lang=ts&"
export * from "./addProductType.vue?vue&type=script&lang=ts&"
import style0 from "./addProductType.vue?vue&type=style&index=0&id=35c97025&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35c97025",
  null
  
)

export default component.exports